import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type HealthDiaryIconProps = Partial<SVGIconProps>;

const HealthDiaryIcon: FC<HealthDiaryIconProps> = (props) => (
  <SVGIcon viewBox="0 0 17 20" {...props}>
    <path
      d="M16 .25H3.25a3 3 0 0 0-3 3V19a.75.75 0 0 0 .75.75h13.5a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75H1.75a1.5 1.5 0 0 1 1.5-1.5H16a.75.75 0 0 0 .75-.75V1A.75.75 0 0 0 16 .25zm-8.25 1.5h4.5V8.5l-1.801-1.35a.75.75 0 0 0-.9 0L7.75 8.5V1.75zm7.5 13.5h-12c-.527-.001-1.044.138-1.5.402V3.25a1.5 1.5 0 0 1 1.5-1.5h3V10a.75.75 0 0 0 .415.671.75.75 0 0 0 .785-.071L10 8.688l2.551 1.912a.75.75 0 0 0 .979-.07.75.75 0 0 0 .22-.53V1.75h1.5v13.5z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default HealthDiaryIcon;
